
import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, throwError } from 'rxjs'
import { environment } from '../../../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class SorteoService {
  constructor(private http: HttpClient) { }
  
  readonly baseURL = environment.DOMAIN_URL+'/api/sorteo/'
  list: string[] = []

  fetchListSorteo(type: string){
    return this.http.get(this.baseURL+type)
    .pipe(catchError(this.errorHandler))
  }

  generateWinner(){
    return this.http.post(this.baseURL,this.list)
    .pipe(catchError(this.errorHandler))
  }

  private errorHandler(error: HttpErrorResponse) {
    if (error.status === 0) console.error('An error occurred:', error.error)
    else console.error(`Backend returned code ${error.status}, body was: `, error.error)
    return throwError(() => new Error('Something bad happened; please try again later.'))
  }
}  